/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useEffect, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ReviewSummaryView.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { findProvinceOrState } from '../../../../redux/reducers/apiReducers/stateProvinceListReducer'

const MailingAddressSummary = ({ t, i18n, setIsError }) => {
  let history = useHistory()

  const { streetAddress, city, postalCode, provinceOrState, country, specify, apartment } = useSelector((state) => state.app.mailingAddress)
  const { states, provinces, countries } = useSelector((state) => state.stateProvince)
  useEffect(() => {
    try {
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [setIsError])

  const editMailingAddressOnClick = () => {
    try {
      history.push(`/${i18n.language}${t('routes.mailing_address')}?isSummary=true`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const displayProvinceOrState = useMemo(() => {
    const provinceOrStateObj =
      country === 'Canada' ? findProvinceOrState(provinces, provinceOrState) : findProvinceOrState(states, provinceOrState)
    return i18n.language === 'en' ? provinceOrStateObj?.name : provinceOrStateObj?.nameFr
  }, [country, provinceOrState, provinces, states, i18n.language])

  const displayCountry = useMemo(() => {
    const countryObj = findProvinceOrState(countries, country)
    return i18n.language === 'en' ? countryObj?.name : countryObj?.nameFr
  }, [countries, country, i18n.language])

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h2>{t('review_summary.mailing_address_title')}</h2>
        </div>
        <div className="button-group">
          <button className="edit-button" onClick={editMailingAddressOnClick} value={t('shared.edit')} name={t('shared.edit')}>
            {t('shared.edit')}
          </button>
        </div>
      </div>
      <div className="row row-odd">
        <div className="col-xs-6">
          <strong>{t('mailing_address.street_address')}</strong>
        </div>
        <div className="col-xs-6">{streetAddress}</div>
      </div>
      <div className="row row-even">
        <div className="col-xs-6">
          <strong>{t('mailing_address.apartment')}</strong>
        </div>
        <div className="col-xs-6">{apartment ? `${t('review_confirmation.unit')} ${apartment}` : ''}</div>
      </div>
      <div className="row row-odd">
        <div className="col-xs-6">
          <strong>{t('mailing_address.city')}</strong>
        </div>
        <div className="col-xs-6">{city}</div>
      </div>
      <div className="row row-even">
        <div className="col-xs-6">
          <strong>{t('mailing_address.postal_code')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {postalCode.toUpperCase()}
        </div>
      </div>
      <div className="row row-odd">
        <div className="col-xs-6">
          <strong>{t('shared.province_select')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {displayProvinceOrState}
        </div>
      </div>
      {specify && (
        <div className="row row-even">
          <div className="col-xs-6">
            <strong>{specify}</strong>
          </div>
          <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}></div>
        </div>
      )}
      <div className="row row-even">
        <div className="col-xs-6">
          <strong>{t('shared.country_select')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          {displayCountry}
        </div>
      </div>
    </Fragment>
  )
}

export default withTranslation('common')(MailingAddressSummary)
